import React from "react";
import { LI } from "../../../../../AbstractElements";
import { Card, CardBody, Col, Form } from "reactstrap";
import { Menu, MenuItem, Typeahead } from "react-bootstrap-typeahead";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { MultipleSectionsHeadersTitle } from "../../../../../Constants/Constants";
import { MultipleSelectionSubTitle, MultipleWithHeadersData } from "../../../../../Data/Forms&Table/Forms/FormWidgets";

const MultipleSectionsWithHeaders = () => {
  const renderMenu = (results: any[], menuProps: any) => {
    const items = results.map((result, index) => {
      if (result.divider === true) <LI key={index} role="separator" className="divider" />;

      if (result.header === true) <LI key={index} className="dropdown-header">{result.name}</LI>;

      return (
        <MenuItem key={index} option={result} position={index}>
          <strong>{result.name}</strong>
        </MenuItem>
      );
    });
    return <Menu {...menuProps}>{items}</Menu>;
  };
  return (
    <Col sm="12" md="6">
      <Card>
        <CommonCardHeader title={MultipleSectionsHeadersTitle} span={MultipleSelectionSubTitle} />
        <CardBody>
          <div id="multiple-datasets">
            <Form className="theme-form">
              <div>
                <Typeahead id="multi" options={MultipleWithHeadersData} placeholder="NBA and NHL teams" renderMenu={renderMenu} labelKey="name" />
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default MultipleSectionsWithHeaders;
